import { type SubmitFunction } from '@remix-run/react'
import { JSON_FORM } from '#app/constants/forms.ts'
import {
	type ExtractFormValuesParams,
	extractFormValues,
} from '#app/features/form/wizard/utils/extractFormValues.ts'
import {
	type BackendActions,
	type QuestionText,
	type JSONState,
} from '#types/form/wizard.ts'
import { type GlobalFormStore } from '../reducer/createGlobalFormStore.ts'

interface CurrentAnswer {
	[key: string]: string
}

interface SetJSONValuesToFormStateParams<T> {
	id: string
	fieldKey: string
	submit: SubmitFunction
	currentQuestionId: string
	CSRFToken: string
	questionText: QuestionText[]
	backendAction: BackendActions
	actionRoute: string
	entireGlobalState: GlobalFormStore<T>
	currentFormContext: CurrentAnswer
	answeredQuestionsStack: JSONState<T>['answeredQuestionsStack']
	questionTree: JSONState<T>['questionTree']
	currentQuestionTreeId: JSONState<T>['currentQuestionTreeId']
	wizardMessages: JSONState<T>['wizardMessages']
	type: JSONState<T>['type']
}

export function setJSONValuesToFormState<T>({
	id,
	questionText,
	fieldKey,
	currentFormContext,
	questionTree,
	backendAction,
	actionRoute,
	type,
	CSRFToken,
	entireGlobalState,
	wizardMessages,
	submit,
}: SetJSONValuesToFormStateParams<T>) {
	if (type !== JSON_FORM) return

	const formData = new FormData()

	let formState = entireGlobalState.formState as any

	const newDataToSend = {
		...formState,
		...currentFormContext,
	}

	const globalFormState = {
		...entireGlobalState,
		editableParents: [],
		formState: newDataToSend,
	} as JSONState<T>

	const formValues: ExtractFormValuesParams<T> = extractFormValues({
		newDataToSend: newDataToSend,
		answeredQuestionsStack: globalFormState.answeredQuestionsStack,
		id,
		typeOfQuestion: 'json',
		fieldKey,
		questionText,
		questionTree: questionTree,
		type,
	}) as any

	formData.append('id', id)
	formData.append('csrf', CSRFToken)
	formData.append('backendAction', backendAction)
	formData.append('questionText', JSON.stringify(questionText, null, 2))
	formData.append('wizardMessages', JSON.stringify(wizardMessages, null, 2))
	formData.append(`currentQuestionValues`, JSON.stringify(formValues))
	formData.append('globalState', JSON.stringify(globalFormState))

	submit(formData, { method: 'post', action: `${actionRoute}` })
}
